import { QueryParams } from 'common/urls/QueryParams';
import React from 'react';
import { DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import {
  SegmentHeader,
  SegmentHeaderContainer,
  SegmentHeaderRow,
  SegmentHeaderTitle,
} from 'src/pages/consumer/dish-first/explore/styles';
import {
  QueryParamsUpdates,
  QueryParamsUpdateType,
  UseDishFirstExploreUrl,
} from 'src/pages/consumer/explore/useExploreUrl';
import styled from 'styled-components';
import { Spacing } from 'web-common/src/shared/styles';
import { FilterCardRow } from '../FilterCardRow';
import { BrowseByTagsFilterButtonProps, FilterCard } from './FilterCard';
import { BrowseByTagsFilterTags } from './types';

const BrowseByTagsContainer = styled(DishFirstExploreWidthLimit)`
  padding-bottom: ${Spacing.SINGLE};
`;

type Category = { icon: JSX.Element; label: string; tag: BrowseByTagsFilterTags };
type CategoryDisplay = Category & { queryParam: QueryParams };

interface BrowseByTagsFilterProps {
  filterTitle: string;
  categories: CategoryDisplay[];
  filters: UseDishFirstExploreUrl;
  updateQueryParams: (updates: QueryParamsUpdates<DishFirstSegmentFilter>, updateType?: QueryParamsUpdateType) => void;
}

export const Filters: React.FC<BrowseByTagsFilterProps> = ({ filterTitle, categories, filters, updateQueryParams }) => (
  <BrowseByTagsContainer>
    <SegmentHeaderContainer>
      <SegmentHeaderRow>
        <SegmentHeader>
          <SegmentHeaderTitle>{filterTitle}</SegmentHeaderTitle>
        </SegmentHeader>
      </SegmentHeaderRow>
    </SegmentHeaderContainer>
    <FilterCardRow data={categories}>
      {categories.map((p, i) => {
        const position = i + 1;
        const buttonProps: BrowseByTagsFilterButtonProps = { ...p, filters, position, updateQueryParams };
        return <FilterCard key={p.tag} {...buttonProps}></FilterCard>;
      })}
    </FilterCardRow>
  </BrowseByTagsContainer>
);
